export default __webpack_public_path__ + "static/media/redkite.d4742b46.webp";